import { createBaseResourceActions } from '../create-base-resource-actions';
import { RefreshTokenResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[REFRESH TOKEN]';
export const refreshTokenActions =
  createBaseResourceActions<RefreshTokenResourceTypeMappings>(domainSlug);
